import { render, staticRenderFns } from "./FestivalInventory.vue?vue&type=template&id=507b3dc5&scoped=true"
import script from "./FestivalInventory.vue?vue&type=script&lang=js"
export * from "./FestivalInventory.vue?vue&type=script&lang=js"
import style0 from "./FestivalInventory.vue?vue&type=style&index=0&id=507b3dc5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "507b3dc5",
  null
  
)

export default component.exports